import React from 'react';

const HandValve1Icon = ({
  width = 64,
  height = 64,
  className = '',
  startColor = '#373737',
  midColor = '#EBEBEB',
  endColor = '#373737',
  stemStartColor,
  stemMidColor,
  stemEndColor
}) => {
  const _stemStart = stemStartColor || startColor;
  const _stemMid = stemMidColor || midColor;
  const _stemEnd = stemEndColor || endColor;
  const uid = React.useId ? React.useId() : 'sc' + Math.random().toString(36).substr(2, 9);

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 112.5 112.5"
      className={className}
    >

<g id={`${uid}_1`}>
	<linearGradient id={`${uid}_2`} gradientUnits="userSpaceOnUse" x1="49.2749" y1="24.6162" x2="63.2246" y2="24.6162">
		<stop offset="0" style={{stopColor: `${_stemStart}`}} />
		<stop offset="0.45" style={{stopColor: `${_stemMid}`}} />
		<stop offset="0.55" style={{stopColor: `${_stemMid}`}} />
		<stop offset="0.76" style={{stopColor: `${_stemEnd}`}} />
		<stop offset="0.77" style={{stopColor: `${_stemEnd}`}} />
		<stop offset="1" style={{stopColor: `${_stemStart}`}} />
	</linearGradient>
	<path fill={`url(#${uid}_2)`} d="M63.225,13.224v22.784h-13.95V13.224H63.225" />
	
		<radialGradient id={`${uid}_3`} cx="56.626" cy="0.7715" r="27.0175" gradientTransform="matrix(1.0146 0 0 0.8433 -0.0414 2.8214)" gradientUnits="userSpaceOnUse">
		<stop offset="0" style={{stopColor: `${_stemMid}`}} />
		<stop offset="0.14" style={{stopColor: `${_stemMid}`}} />
		<stop offset="0.4" style={{stopColor: `${_stemMid}`}} />
		<stop offset="0.75" style={{stopColor: `${_stemEnd}`}} />
		<stop offset="1" style={{stopColor: `${_stemStart}`}} />
	</radialGradient>
	<path fill={`url(#${uid}_3)`} d="M28.136,14.237c0-7.374,13.578-14.416,28.744-14.416s27.484,6.485,27.484,13.859" />
</g>
<g id={`${uid}_4`}>
	<linearGradient id={`${uid}_5`} gradientUnits="userSpaceOnUse" x1="56.2505" y1="101.9248" x2="56.2505" y2="66.8252">
		<stop offset="0" style={{stopColor: `${startColor}`}} />
		<stop offset="0.45" style={{stopColor: `${midColor}`}} />
		<stop offset="0.55" style={{stopColor: `${midColor}`}} />
		<stop offset="0.76" style={{stopColor: `${endColor}`}} />
		<stop offset="0.77" style={{stopColor: `${endColor}`}} />
		<stop offset="1" style={{stopColor: `${startColor}`}} />
	</linearGradient>
	<path fill={`url(#${uid}_5)`} d="M0,66.825h112.5v35.1H0V66.825" />
</g>
<g id={`${uid}_6`}>
	<linearGradient id={`${uid}_7`} gradientUnits="userSpaceOnUse" x1="38.7002" y1="45.6748" x2="73.7998" y2="45.6748">
		<stop offset="0" style={{stopColor: `${_stemStart}`}} />
		<stop offset="0.45" style={{stopColor: `${_stemMid}`}} />
		<stop offset="0.55" style={{stopColor: `${_stemMid}`}} />
		<stop offset="0.76" style={{stopColor: `${_stemEnd}`}} />
		<stop offset="0.77" style={{stopColor: `${_stemEnd}`}} />
		<stop offset="1" style={{stopColor: `${_stemStart}`}} />
	</linearGradient>
	<path fill={`url(#${uid}_7)`} d="M73.8,35.1v21.15H38.7V35.1H73.8" />
	<linearGradient id={`${uid}_8`} gradientUnits="userSpaceOnUse" x1="56.2505" y1="112.5" x2="56.2505" y2="56.2505">
		<stop offset="0" style={{stopColor: `${startColor}`}} />
		<stop offset="0.45" style={{stopColor: `${midColor}`}} />
		<stop offset="0.55" style={{stopColor: `${midColor}`}} />
		<stop offset="0.76" style={{stopColor: `${endColor}`}} />
		<stop offset="0.77" style={{stopColor: `${endColor}`}} />
		<stop offset="1" style={{stopColor: `${startColor}`}} />
	</linearGradient>
	<path fill={`url(#${uid}_8)`} d="M28.125,56.25h56.25v56.25h-56.25V56.25" />
</g>
<g id={`${uid}_9`}>
	<linearGradient id={`${uid}_10`} gradientUnits="userSpaceOnUse" x1="10.5747" y1="112.5" x2="10.5747" y2="56.2505">
		<stop offset="0" style={{stopColor: `${startColor}`}} />
		<stop offset="0.45" style={{stopColor: `${midColor}`}} />
		<stop offset="0.55" style={{stopColor: `${midColor}`}} />
		<stop offset="0.76" style={{stopColor: `${endColor}`}} />
		<stop offset="0.77" style={{stopColor: `${endColor}`}} />
		<stop offset="1" style={{stopColor: `${startColor}`}} />
	</linearGradient>
	<path fill={`url(#${uid}_10)`} d="M0,56.25h21.15v56.25H0V56.25" />
	<linearGradient id={`${uid}_11`} gradientUnits="userSpaceOnUse" x1="101.9248" y1="112.5" x2="101.9248" y2="56.2505">
		<stop offset="0" style={{stopColor: `${startColor}`}} />
		<stop offset="0.45" style={{stopColor: `${midColor}`}} />
		<stop offset="0.55" style={{stopColor: `${midColor}`}} />
		<stop offset="0.76" style={{stopColor: `${endColor}`}} />
		<stop offset="0.77" style={{stopColor: `${endColor}`}} />
		<stop offset="1" style={{stopColor: `${startColor}`}} />
	</linearGradient>
	<path fill={`url(#${uid}_11)`} d="M91.35,56.25h21.15v56.25H91.35V56.25" />
</g>
    </svg>
  );
};

export default HandValve1Icon;
